<template>
    <v-card>
        <span class="px-2">Accommodation: {{this.hspt.huis_code}} </span>
        <span class="px-2">Status: {{this.hspt.stat_code}} </span>
        <span class="px-10">Arrival: {{this.hspt.hspt_aank_van_dat}} - {{this.hspt.hspt_aank_tm_dat}} </span>
    </v-card>    
</template>

<script>
  export default {
    props: {
      hspt: Object
    },
  }
</script>